import request from '@aned/request';
import { removeApiPrefix } from '@/utils/requestPath';

// 城市到城市标准时效 - 分页查询
export const cityToCityStandardPageApi = '/api/cityToCity/dispatchCityToCity/selectPage';
// 城市到城市标准时效 - 导出
export const cityToCityStandardExportApi = '/api/cityToCity/dispatchCityToCity/export';
// 城市到城市标准时效 - 查询分拨交/接件操作时长配置
export const cityToCityStandardGetConfigApi = '/api/cityToCity/dispatchCityToCity/getConfig';
// 城市到城市标准时效 - 保存分拨交/接件操作时长配置
export const cityToCityStandardSaveConfigApi = '/api/cityToCity/dispatchCityToCity/saveConfig';

export const cityToCityStandardPagePath = removeApiPrefix(cityToCityStandardPageApi);
export const cityToCityStandardExportPath = removeApiPrefix(cityToCityStandardExportApi);
export const cityToCityStandardConfigPath = removeApiPrefix(cityToCityStandardSaveConfigApi);

// 城市到城市标准时效 - 分页查询
export async function fetchCityToCityStandardPage(params) {
  return request(cityToCityStandardPageApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 城市到城市标准时效 - 导出
export async function fetchCityToCityStandardExport(params) {
  return request(cityToCityStandardExportApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 城市到城市标准时效 - 查询分拨交/接件操作时长配置
export async function fetchCityToCityStandardOperationConfig() {
  return request(cityToCityStandardGetConfigApi, {
    method: 'POST',
    reqType: 'json',
    module: 'basic',
  });
}

// 城市到城市标准时效 - 保存分拨交/接件操作时长配置
export async function fetchCityToCityStandardSaveOperationConfig(params) {
  return request(cityToCityStandardSaveConfigApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}
